import {Component, OnDestroy, OnInit} from '@angular/core';
import {DropdownOption} from "../../../../../../models/dropdown-option.model";
import * as Validation
  from "../../../../../shared/constants/validation.constants";
import {roles} from "../../../../../shared/constants/common.constants";
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../state/app.state";
import {Router} from "@angular/router";
import {CommonService} from "../../../../../shared/services/common.service";
import {
  FetchUserStatusListFilterRequest,
  SaveConfigId
} from "../../../core/group-dashboard.actions";
import {userStatusListFilter} from "../../../core/group-dashboard.selector";
import {GroupDashboardService} from "../../../services/group-dashboard.service";

@Component({
  selector: 'app-participant-behaviour-information-filter',
  templateUrl: './participant-behaviour-information-filter.component.html',
  styleUrls: ['./participant-behaviour-information-filter.component.css']
})
export class ParticipantBehaviourInformationFilterComponent implements OnInit,
                                                                       OnDestroy {
  loading: boolean = false;
  statusFilterList: DropdownOption[] = [];
  errorMessages: any = {};
  validation = Validation;
  errorMessageMap = {
    'role': {
      required: 'This field is required.'
    },
    'session': {
      required: 'This field is required.'
    },
    'status': {
      required: 'This field is required.'
    },
    'searchText': {
      required: 'This field is required.'
    },
  }

  roleFilterList: DropdownOption[] = [
    {
      key: roles.adult,
      value: 'Adult',
    },
    {
      key: roles.participant,
      value: 'Participant',
    },
  ];

  sessionFilterList: DropdownOption[] = [
    {
      key: 1,
      value: 'Up to S26',
    },
    {
      key: 2,
      value: 'After S26',
    },
  ];

  form = new FormGroup({
    role: new FormControl([roles.participant]),
    session: new FormControl({value: 1, disabled: false}, {
      validators: [
        Validators.required
      ]
    }),
    status: new FormControl(null),
    searchText: new FormControl(null),
    searchGroup: new FormControl(''),
  })
  config = [
    {
      id: 1,
      label: 'Red Light Foods',
      isSelected: true
    },
    {
      id: 2,
      label: 'Physical Activity',
      isSelected: false
    },
    {
      id: 3,
      label: 'Screen Time',
      isSelected: false
    }

  ]
  clientId: any;
  private readonly OnDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private commonService: CommonService,
    private groupDashboardService: GroupDashboardService,
  ) {
    this.store.dispatch(FetchUserStatusListFilterRequest());
  }

  ngOnInit() {
    const {...filters} = this.form.getRawValue();
    this.groupDashboardService.onParticipantBehaviourInformationFilterChange.next(filters)

    this.store.select(userStatusListFilter)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe((data) => {
        this.statusFilterList = data.list;
      });
  }

  apply() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }
    if (!this.form.dirty) { // check is there any change
      return;
    }
    // changes just applied, so marking the form as un-dirty to avoid applying same filters again without changing anything
    this.form.markAsPristine();

    // EXTRACT VALUE FROM FORM//
    const {...filters} = this.form.getRawValue();
    this.groupDashboardService.onParticipantBehaviourInformationFilterChange.next(filters)
  }

  checkForErrors(currentField ?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  select(configId) {
    this.config.map((e) => {
      e.isSelected = e.id === configId;
    });
    this.store.dispatch(SaveConfigId({configId}));
  }

  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }
}
